import React from 'react'
import { connect } from "react-redux"
import CheckIcon from '../assets/tick.svg'

class RegisterPlan extends React.Component{

    render(){
        const { registerPlan,  dispatchRegisterPlan } = this.props;
        const AccountTypeButton = ({title, sub, active, onClick}) => {
            let buttonStyle = {
                borderRadius: '5px',
                border: 'solid 2px #e4e4eb',
                backgroundColor: '#fff'
            }
    
            let activeButtonStyle = {
                borderRadius: '5px',
                borderStyle: 'solid',
                borderWidth: '2px',
                background: 'linear-gradient(79deg, #53a0fe, #43c0dc 6%, #33e2b9 63%, #43c0dc 90%, #53a0fe)',
                color:'#32e2b9'
            }
    
            return (
                <div className='accountTypeButton' onClick={onClick} style={active ? activeButtonStyle : buttonStyle}>
                    <div className="inner-area">

                        <h2>{title}</h2>
                        <p>{sub}</p>
                    </div>
                    {active ? <CheckIcon alt='Check Icon' className='account-type-icon1' /> : null}
                </div>
            )
        }

        return (
            <div className='accountTypes'>
                <AccountTypeButton 
                    title='Förskola - Åk 3'
                    sub='(Ålder 3-9 år)'
                    active={registerPlan === 'junior' ? true : false}
                    onClick={() => dispatchRegisterPlan('junior')}
                />
                <AccountTypeButton
                    title='Åk 4 - Åk 9'
                    sub='(Ålder 10-16 år)'
                    active={registerPlan === 'senior' ? true : false}
                    onClick={() => dispatchRegisterPlan('senior')}
                />
            </div>
        )
    }
}

const reduxRegisterState = (state) => {
    return {
        registerPlan: state.registerPlan,
    }
}
  
const reduxRegisterStateDispatch = dispatch => {
    return { 
        dispatchRegisterPlan: (plan) => dispatch({ type: `REGISTER_PLAN`, value: plan }),
    }
}

export default connect(reduxRegisterState, reduxRegisterStateDispatch)(RegisterPlan);